import * as React from 'react';
import { dangerousInnerHtml } from '../utils';
import { get } from 'lodash';

interface DealProps {
	result: wpPost,
	placeholder: wpImage
}

export const ResultDeal: React.SFC<DealProps> = ({result, placeholder}) => {
	const featuredImage = result.search_thumbnail;

	let src, alt;

	if ( featuredImage ) {
		src = featuredImage.src;
		alt = featuredImage.alt;
	} else {
		src = placeholder.sizes['search-page-article-image'];
		alt = placeholder.alt;
	}

	return (
		<div className="item">
			<a href={result.link} className="tease-news tease">

				<div className="tease-news__image-container">
					<img src={src} alt={alt} />
				</div>

				<div className="tease-news__content">
					<div className="tease-news__content__padded">
						<a href="" className="article__tax-terms__item article__tax-terms__item--light tease-news__tag" dangerouslySetInnerHTML={dangerousInnerHtml(result.primary_category_name)}/>
						<h3 className="tease-news__title tease-news__title--large" dangerouslySetInnerHTML={dangerousInnerHtml(result.title.rendered)}/>
					</div>
				</div>

			</a>
		</div>
	)
}
